/**
 * Invoicing demo tenant: same app and API behavior as production (upload, NEX reads, reconciliation),
 * except the API skips POST/PUT to NEX when `organizations.demoMode` is true (see updateInvoice / processInvoice).
 */
import type { SessionContextType } from '../contexts/SessionContext';

/** Matches Mongo `organizations._id` for the legacy "Invoicing Demo" org (string compare after JSON). */
export const INVOICING_DEMO_ORGANIZATION_ID = '6a0232584335e4d6e2727a94';

export function isInvoicingDemoSession(ctx: SessionContextType | undefined): boolean {
    if (!ctx || ctx.isAuthenticated !== true) return false;
    if (ctx.demoMode === true) return true;
    const oid = ctx.organizationId != null ? String(ctx.organizationId) : '';
    return oid.toLowerCase() === INVOICING_DEMO_ORGANIZATION_ID.toLowerCase();
}
